<form (ngSubmit)="onClickSearch()">
    <p-dialog
    [contentStyle]="{ overflow: 'auto' }"
    [styleClass]="'sm:col-6 md:col-6 lg:col-5 xl:col-4'"
    [(visible)]="visible"
    [modal]="true"
    [closable]="true"
    (onHide)="close()"
    >
        <ng-template pTemplate="header">
            <span class="p-dialog-title">
                {{'Srch_In' | translate}}
            </span>            
        </ng-template>
        <div class="col-12">
            <input
                [(ngModel)]="searchText"
                [ngModelOptions]="{standalone: true}"
                class="p-inputtext size_cent"
                pInputText
                type="text"
                maxlength="64"
                autofocus
            />
        </div>
        <div class="col-12 md:col-12 align-right">
            <button type="button" pButton class="margin p-button-primary p-button-outlined" (click)="closeSearch()" label="{{'Cancel' | translate}}"></button>
            <button type="button" pButton class="margin" (click)="onClickSearch()" label="{{'Valid' | translate}}"></button>
        </div>
    </p-dialog>
</form>

